import { useQuery } from "react-query";

import { authGet } from "@api";
import { useOrg } from "@hooks/useOrg";

import { RbacRole } from "@pages/settings/types";

export type InvitedUser = {
  id: number;
  organization_id: number;
  invited_email: string;
  expiration_time: string;
  status: string;
  initial_role: RbacRole;
};

type InvitedUsers = { user_invites: InvitedUser[] };

export const useInvitations = () => {
  const org = useOrg();

  return useQuery(
    ["invitations", { org }],
    () =>
      authGet<InvitedUsers>(
        `/api/agent/organizations/${org?.organization_id}/user_invites`
      ),
    {
      enabled: !!org,
    }
  );
};
